import React, { Component } from 'react';
import { connect } from 'react-redux';
import './login.scss';
import { Modal, Button, message } from 'antd';
import logo from '../../../images/logo.png';
import { fromValidate } from '../../../helpers';
import { history } from '../../../helpers'
import { sendOtp, verifyOtp, login } from '../action/user.actions'
import { Select } from 'antd';
import { Link } from "react-router-dom";

const { Option } = Select;

class Login extends Component {
	constructor(props) {
		super(props);
		this.state = {
			formError: {},
			formSubmit: false,
			user: {
				phone: '',
				otp: '',
				username: '',
				password: ''
			},
			signInWithOtp: true
		}
	}

	onChangeLoginMethod = () => {
		this.setState({ signInWithOtp: !this.state.signInWithOtp })
	}
	handleChange = (e) => {
		const user = Object.assign({}, this.state.user)
		const name = e.target.name;
		const value = e.target.value;
		var letters = /^[0-9]+$/;
		if (name == 'phone') {
			if (value.match(letters) || e.target.value == '') {
				user[name] = value;
			}
		} else {
			user[name] = value;
		}

		this.setState({ user });

		if (this.state.formSubmit) {
			this.setState({ formError: {} })
			const formValidation = fromValidate(this.fromNode);
			if (!formValidation.valid) {
				this.setState({ formError: formValidation.invalidationEle })
			}
		}
	}

	handleDropdownChange = (name, value) => {
		const user = Object.assign({}, this.state.user)
		user[name] = value;
		this.setState({ user });
	}

	goToForgotPassword = () => {
		history.push('/forgotPassword')
	}

	handleSubmit = (e) => {
		e.preventDefault();
		const { dispatch } = this.props;
		const { user, signInWithOtp, role_count } = this.state;
		if (signInWithOtp) {
			if (!user.phone) {
				message.error('Please enter the valid phone number');
				return;
			}
			if (!user.otp) {
				message.error('Please enter otp');
				return;
			}

			if (role_count > 1 && !user.role) {
				message.error('Please select a role to login');
				return;
			}

			dispatch(verifyOtp(this.state.user))
				.then((res) => {
					if (res.token) {
						history.push('/')
					}
					this.showModalLogin()

				})
				.catch(e => {
					message.error(e.message);
				})
		}
		else {

			if (!user.username) {
				message.error('Please enter the valid user number');
				return;
			}
			if (!user.password) {
				message.error('Please enter Password');
				return;
			}

			dispatch(login(user.username, user.password))
				.then((res) => {
					if (res.token) {
						history.push('/')
					}
				})
				.catch(e => {
					message.error(e.message);
				})
		}
	}

	getVerificationCode = () => {
		const { dispatch } = this.props;
		const phone = this.state.user.phone;
		if (!phone) {
			message.error('Please enter the valid phone number')
			return;
		}
		dispatch(sendOtp({ phone }))
			.then((res) => {
				this.setState({ role_count: res.data.role_count })
				message.success('OTP send to your register moble number')
			})
	}

	showModalLogin = () => {
		this.setState({
			visibleLogin: true,
		});
	};

	handleCancelLogin = e => {
		console.log(e);
		this.setState({
			visibleLogin: false,
		});
	};

	goToSignUp = (type) => {
		history.push(`/${type}/register`)
	}

	render() {
		const { user, formError, formSubmit, signInWithOtp, role_count } = this.state;
		return (
			<div className='login-container'>
				<div className='login-box'>
					<div className='logo-box-logo'>
						<Link to="/">
							<img className='login-logo-image' src={logo}></img>
						</Link>
					</div>
					<div className='txt-login'>Login to your Account</div>
					<form ref={node => this.fromNode = node}
						onSubmit={(e) => { this.handleSubmit(e) }}>
						<div>
							{
								signInWithOtp &&
								<div>
									<div>
										<input
											required
											type="text"
											className='form-textfield-containt'
											placeholder="Enter Mobile Number"
											name="phone"
											value={user.phone}
											onChange={(e) => { this.handleChange(e) }}
										/>
									</div>
									<div className="otp-box-con">
										<input
											required
											type="text"
											className='form-textfield-containt'
											placeholder="Enter OTP"
											name="otp"
											value={user.otp}
											onChange={(e) => { this.handleChange(e) }}
										/>
										<div className="verif-txt" onClick={() => { this.getVerificationCode() }}>Get verification code</div>
									</div>

									{
										role_count ? <div className="otp-box-con">
											<Select
												placeholder="Choose Role"
												value={user.role}
												onChange={(e) => { this.handleDropdownChange('role', e) }}
											>
												<Option value="P">Provider</Option>
												<Option value="C">Customer</Option>
											</Select>
										</div> : null}



								</div>
							}
							{
								!signInWithOtp &&
								<div>
									<div>
										<input
											required
											id="name"
											type="text"
											className='form-textfield-containt'
											placeholder="User Name"
											value={user.username}
											name="username"
											onChange={(e) => { this.handleChange(e) }}
										/>
									</div>
									<div className="otp-box-con">
										<input
											required
											type="password"
											className='form-textfield-containt'
											placeholder="Password"
											value={user.password}
											name="password"
											onChange={(e) => { this.handleChange(e) }}
										/>
									</div>
									<div className='txt-forgot' onClick={this.goToForgotPassword}>Forgot your password?</div>
								</div>
							}
							{
								(!signInWithOtp) &&
								<div className="login-footer-buttons">
									<Button htmlType="submit" className='btn-signin'>Sign in</Button>
									<div className="sign-in-txt-very" onClick={() => this.onChangeLoginMethod()}>Sign in with SMS</div>
								</div>
							}

							{
								(signInWithOtp) &&
								<div className="login-footer-buttons">
									<Button htmlType="submit" className='btn-signin'>Sign in/Sign up</Button>
									<div className="sign-in-txt" onClick={() => this.onChangeLoginMethod()}>Sign in with password</div>
									<div className="sign-in-txt-very" onClick={() => { this.getVerificationCode() }} >Can't receive verification code?</div>
								</div>
							}
						</div>
					</form>

					<Modal
						title="Sign Up as"
						visible={this.state.visibleLogin}
						okText="Next"
						onCancel={this.handleCancelLogin}
						footer={false}
					>
						<div className="">
							<div className="checkbox-main">
								<Button htmlType="button"
									className='customer-btn'
									onClick={() => { this.goToSignUp('customer') }}
								>Customer</Button>
							</div>
							<div className="checkbox-main">
								<Button htmlType="button"
									onClick={() => { this.goToSignUp('provider') }}
									className='customer-btn provider-btn'>Provider</Button>
							</div>
						</div>
					</Modal>

				</div>
			</div>
		)
	}
}

function mapStateToProps(state) {
	const { user } = state.authentication;
	return {
		user,
	}
}
export default connect(mapStateToProps)(Login);